import React, { ReactNode } from 'react'
import styled from 'styled-components'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'

interface Props {
  flightDate?: string
  flightTime?: string
  airportCode?: ReactNode
}

const Container = styled(VerticalSpacer)`
  & *:empty {
    display: none;
  }
`

function FlightLocationGroup({ flightDate, flightTime, airportCode }: Props) {
  return (
    <Container gap={4}>
      <BodyText variant="small">{flightDate}</BodyText>
      <div>
        <Heading variant="heading6">{flightTime}</Heading>
        <BodyText variant="medium" colour="neutral-two">
          {airportCode}
        </BodyText>
      </div>
    </Container>
  )
}

export default React.memo(FlightLocationGroup)
